const Footer = () => {
    return (
        <footer className="footer">
            <p><small>Jing Li &copy; 2025</small></p>
        </footer>
    );
}

export default Footer;